export function IntroObject(){
    //////////////////////////IntroJs//////////////////////////////////////
    return  {
      steps:[
      {
          element: '#step1',
          intro: "با کلیک روی این دکمه میتوانید به تمامی خدمات بازارمورد نظر دسترسی داشته باشید.",
          position: 'top'
  
      },
      {
          element: '#step2',
          intro: "آمار خدمات ارائه شده",
          position: 'left'
  
      },
      {
          element: '#step3',
          intro: "آمار تعداد کارگزاران",
          position: 'right'
  
      },
      {
          element: '#step4',
          intro: "آمار تعداد حامیان",
          position: 'right'
  
      },
      {
          element: '#step5',
          intro: "آمار خدمات درحال انجام",
          position: 'right'
  
      },
      {
          element: '#step6',
          intro: "با کلیک روی این دکمه میتوانید اولین مرحله از پروسه کارگزار شدن را طی کنید.",
          position: 'right'
  
      },
      {
          element: '#step7',
          intro: "در این قسمت میتوانید کسانی که از کارگزاری شما در خدمات مختلف استفاده کرده اند را مشاهده کنید.",
          position: 'right'
  
      },
      {
          element: '#step8',
          intro: "در اینجا لیست خدماتی که شما برای آن کارگزار شده اید را میتوانید مشاهده کنید.",
      },
      {
          element: '#step9',
          intro: "در این قسمت  خدمات درحال انجام را میتوانید مشاهده کنید.",
      },
      {
          element: '#step10',
          intro: "با کلیک روی این دکمه میتوانید اولین مرحله از پروسه حامی شدن را طی کنید.",
      },
      {
          element: '#step11',
          intro: "در این قسمت میتوانید کسانی که از حمایت های شما در خدمات مختلف استفاده کرده اند را مشاهده کنید.",
      },
      {
          element: '#step12',
          intro: "در اینجا لیست خدماتی که شما برای آن حامی شده اید را میتوانید مشاهده کنید.",
      },
      {
          element: '#step13',
          intro: "در این قسمت  حمایت های درحال انجام را میتوانید مشاهده کنید.",
      },
      {
          element: '#step14',
          intro: "در اینخا آخرین درخواست های خود را میتوانید در جدول مشاهده کنید.",
      },
  
  ],
      showStepNumbers: true,
      showBullets: true,
      exitOnOverlayClick: true,
      exitOnEsc:true,
      prevLabel: '<span style="color:green;">قبلی</span>',
      skipLabel: 'خروج',
      doneLabel: 'ممنونم',
      nextLabel: 'بعدی',
      } 
    //////////////////////////IntroJs//////////////////////////////////////

}